module.exports = __webpack_public_path__ + "static/teepee-favicon-source-white-f8aa2a3b0a9d40177500cff59cc3a019.png";